import { render, staticRenderFns } from "./downHome.vue?vue&type=template&id=b7af3e4c&scoped=true&"
import script from "./downHome.vue?vue&type=script&lang=js&"
export * from "./downHome.vue?vue&type=script&lang=js&"
import style0 from "./downHome.vue?vue&type=style&index=0&id=b7af3e4c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7af3e4c",
  null
  
)

export default component.exports